/**
 * Appends " for your Hilux" to a collection heading — but only when the page
 * is actually filtered to that vehicle.
 *
 * The model comes from the URL's own filter param, not from localStorage: a
 * remembered truck must not caption an unfiltered grid as "for your Leopard 8"
 * while all 157 products are showing. The URL is also what Shopify's full-page
 * cache varies on, so this stays correct for every shopper.
 */
class VehicleSuffix extends HTMLElement {
  connectedCallback() {
    const model = new URLSearchParams(window.location.search).get('filter.p.m.custom.vehicle_model');
    if (!model) return;

    const template = this.dataset.template || '';
    // textContent, not innerHTML — the model comes from the URL.
    this.textContent = template.includes('%s') ? template.replace('%s', model) : ` ${model}`;
  }
}

if (!customElements.get('tt-vehicle-suffix')) {
  customElements.define('tt-vehicle-suffix', VehicleSuffix);
}
